<template>
  <v-card flat class="elevation-1 mx-2 dashboard-filters-card">
    <v-card-title class="pb-2 h5">{{$t('dashboard.filters')}}</v-card-title>
    <v-card-text class="pt-2">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <date-input
            v-if="filters[0].field == 'dateFrom'"
            v-model="filters[0].value"
            :label="$t('media.file.from')"
            prepend-icon="event"
            color="secondary"
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <date-input
            v-model="filters[1].value"
            :label="$t('media.file.until')"
            prepend-icon="event"
            color="secondary"
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="selectedDeposito"
            :items="depositosWithAll"
            item-text="nombre"
            item-value="id"
            :label="$t('dashboard.deposito') || 'Depósito'"
            prepend-icon="store"
            color="secondary"
            hide-details
            :rules="[v => !!v || 'Depósito es requerido']"
            required
            @change="onDepositoChange"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="localSelectedCharts"
            :items="availableCharts"
            item-text="label"
            item-value="key"
            :label="$t('dashboard.selectCharts')"
            multiple
            deletable-chips
            prepend-icon="bar_chart"
            color="secondary"
            hide-details
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index === 0"
                small
                color="secondary"
                text-color="white"
                class="mr-2"
              >
                {{ item.label }}
                <span v-if="localSelectedCharts.length > 1" class="ml-1">
                  (+{{ localSelectedCharts.length - 1 }})
                </span>
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="4" class="d-flex align-center">
          <v-btn small text color="secondary" class="mx-2" @click="cleanFilters()">{{
            "Limpiar filtros"
          }}</v-btn>
          <v-btn small color="secondary" class="mx-2" @click="setFilters()">{{
            "Aplicar filtros"
          }}</v-btn>
          <v-btn small color="green" class="mx-2" @click="downloadReporteStockMovimientos()">{{
            "Descargar Reporte de Stock y Movimientos"
          }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import { DateInput } from '@dracul/dayjs-frontend';
import MovimientoProvider from "../../../../movimiento/providers/MovimientoProvider";
import DepositoProvider from "../../../../deposito/providers/DepositoProvider";
import UserConfigurationProvider from "../../../../user-configuration/providers/UserConfigurationProvider";
import dayjs from 'dayjs'
import * as XLSX from 'xlsx/xlsx.mjs';
import { filterMovimientosByDate } from '../../../util/dateFilters';

export default {
  name: "DashboardFilters",
  components: { DateInput },
  props: {
    value: Array,
    selectedCharts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    filters: {
      get() {return this.value},
      set(val) {
        this.$emit('input', val)
      }
    },
    localSelectedCharts: {
      get() {
        const charts = this.selectedCharts || [];
        // Si es un array reactivo, devolver una copia limpia
        if (charts && charts._ob_ && typeof charts.length === 'number') {
          return Array.from(charts);
        }
        return Array.isArray(charts) ? charts : [];
      },
      set(val) {
        // Extraer el array real antes de emitir
        let chartsToEmit = val;
        if (chartsToEmit && chartsToEmit._ob_ && typeof chartsToEmit.length === 'number') {
          chartsToEmit = Array.from(chartsToEmit).filter(item => typeof item === 'string' && item.length > 0);
        } else if (Array.isArray(chartsToEmit)) {
          chartsToEmit = chartsToEmit.filter(item => typeof item === 'string' && item.length > 0);
        } else {
          chartsToEmit = [];
        }
        this.$emit('chartSelectionChange', chartsToEmit);
      }
    },
    depositosWithAll() {
      // Si hay m�s de un dep�sito, agregar la opci�n "Todos los dep�sitos"
      if (this.depositos && this.depositos.length > 1) {
        return [
          ...this.depositos,
          { id: 'ALL', nombre: 'Todos los depósitos' },
        ];
      }
      return this.depositos || [];
    }
  },
  data() {
    return {
      selectType: [
        { text: this.$t("text"), value: "text" },
        { text: this.$t("image"), value: "image" },
        { text: this.$t("application"), value: "application" },
        { text: this.$t("audio"), value: "audio" }
      ],
      movimientos: [],
      depositos: [],
      selectedDeposito: null,
      loadingDepositos: false,
      availableCharts: [
        { key: 'ventasPorModelo', label: this.$t('dashboard.ventasPorModelo.title') },
        { key: 'ventasPorMedioDePago', label: this.$t('dashboard.ventasPorMedioDePago.title') },
        { key: 'ventasPorTamanio', label: this.$t('dashboard.ventasPorTamanio.title') },
        { key: 'productosMasVendidos', label: this.$t('dashboard.productosMasVendidos.title') },
        { key: 'ingresosVsDescuentos', label: this.$t('dashboard.ingresosVsDescuentos.title') },
        { key: 'devolucionesPorDia', label: this.$t('dashboard.devolucionesPorDia.title') },
        { key: 'ordenesVentaPorDia', label: this.$t('dashboard.ordenesVentaPorDia.title') },
        { key: 'ordenesCompraPorDia', label: this.$t('dashboard.ordenesCompraPorDia.title') },
        { key: 'flujoCajaPorDia', label: this.$t('dashboard.flujoCajaPorDia.title') },
      ]
    }
  },
  created() {
    this.loadDepositos();
    this.loadUserDeposito();
  },
  methods: {
    loadDepositos() {
      this.loadingDepositos = true;
      DepositoProvider.fetchDepositos().then(r => {
        this.depositos = r.data.depositoFetch || [];
      }).catch(err => {
        console.error('Error loading depositos:', err);
      }).finally(() => {
        this.loadingDepositos = false;
      });
    },
    loadUserDeposito() {
      UserConfigurationProvider.getUserConfiguration().then(r => {
        const userConfig = r.data.userConfigurationGet;
        if (userConfig && userConfig.depositoIdSeleccionado) {
          this.selectedDeposito = userConfig.depositoIdSeleccionado;
          this.onDepositoChange(userConfig.depositoIdSeleccionado);
        }
      }).catch(err => {
        console.error('Error loading user deposito:', err);
      });
    },
    onDepositoChange(depositoId) {
      // Buscar el filtro de dep�sito o crearlo
      let depositoFilter = this.filters.find(f => f.field === 'deposito');
      if (!depositoFilter) {
        depositoFilter = {
          field: 'deposito',
          operator: depositoId === 'ALL' ? '$in' : '$eq',
          value: depositoId
        };
        this.filters.push(depositoFilter);
      } else {
        depositoFilter.value = depositoId;
        depositoFilter.operator = depositoId === 'ALL' ? '$in' : '$eq';
      }
      // Emitir actualizaci�n de filtros
      this.$emit("updateFilters", this.filters);
    },
    setFilters() {
      this.$emit("updateFilters", this.filters);
    },
    cleanFilters() {
      this.filters.forEach(filter => {
        if (filter.field !== 'deposito') {
          filter.value = null;
        }
      });
      this.$emit("clearFilter", this.filters);
    },
    downloadExcel() {
      this.movimientos = [];
      
      MovimientoProvider.fetchMovimientos().then(r => {
          this.movimientos = r.data.movimientoFetch
          this.movimientos.map(item => {
            for (let field in item) {
              switch (field) {
                case 'recargo': 
                  item[field] = item.recargo;
                  break;
                case 'fecha':
                  item[field] = dayjs(parseInt(item[field])).format('DD-MM-YYYY HH:mm:ss') 
                  break;
                case 'precioTotal':
                  item[field] = item[field].toFixed(2);
                  break;
              }
            }
            return item;
          })

          this.movimientos = this.movimientos.reverse();
          let csvContent = "data:text/xlsx;charset=utf-8,"
          csvContent += [
            Object.keys(this.movimientos[0]).join(";"),
            ...this.movimientos.map(item => Object.values(item).join(";"))
          ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "")
    
          const data = encodeURI(csvContent)
          const link = document.createElement("a")
    
          link.setAttribute("href", data)
          link.setAttribute("download", "Mara Indumentaria - Movimientos.xlsx")
          link.click()
        }).catch(err => {
            console.error(err)
        }).finally(() => this.loading = false)
    },
    downloadReporteStockMovimientos() {
      this.movimientos = [];
      const fechaDesde = this.filters[0].value;
      const fechaHasta = this.filters[1].value;
      MovimientoProvider.fetchMovimientos(fechaDesde, fechaHasta).then(r => {
          this.movimientos = r.data.movimientoFetch
          this.movimientos = this.filterByDate(this.movimientos);
          let newItem = {};
          let itemsTotales = [];
          
          this.movimientos.forEach(movimiento => {
            movimiento.itemsCarrito.forEach((itemCarrito) => {
              if (itemCarrito.producto) {
                // Precio base del item (precio original del producto)
                const precioBase = itemCarrito.precioBase || itemCarrito.producto.precio || 0;
                // Precio total del item
                const precioTotalProducto = itemCarrito.precioTotal || precioBase;
                
                newItem = {
                  fecha: dayjs(parseInt(movimiento.fecha)).format('DD-MM-YYYY HH:mm:ss'),
                  marca: itemCarrito.producto.marca ? itemCarrito.producto.marca.nombre : null,
                  modelo: itemCarrito.producto.modelo ? itemCarrito.producto.modelo.nombre : null,
                  tamanio: itemCarrito.producto.tamanio ? itemCarrito.producto.tamanio.tamanio: null,
                  cantidad: itemCarrito.cantidad,
                  medioDePago: movimiento.medioDePago,
                  precioBase: parseFloat(precioBase.toFixed(2)),
                  precioTotalProducto: parseFloat(precioTotalProducto.toFixed(2)),
                  descuento: movimiento.descuento || 0,
                  recargo: movimiento.recargo || 0,
                }
                itemsTotales.push(newItem);
              }
            });
          });

          itemsTotales = itemsTotales.reverse();

          let movimientosArray = [];
          movimientosArray.push([
            'Fecha', 
            'Marca', 
            'Modelo', 
            'Tamano', 
            'Cantidad vendida', 
            'Metodo de pago', 
            'Precio Base', 
            'Precio Total Producto', 
            'Descuento (%)', 
            'Recargo (%)'
          ]);

          itemsTotales.forEach((movimiento) => {
            movimientosArray.push([
              movimiento.fecha,
              movimiento.marca,
              movimiento.modelo,
              movimiento.tamanio,
              movimiento.cantidad,
              movimiento.medioDePago,
              movimiento.precioBase,
              movimiento.precioTotalProducto,
              movimiento.descuento,
              movimiento.recargo
            ]);
          });

          let workbook = XLSX.utils.book_new(),
          worksheet = XLSX.utils.aoa_to_sheet(movimientosArray);
          workbook.SheetNames.push("Reporte de Stock");
          workbook.Sheets["Reporte de Stock"] = worksheet;

          let xlsbin = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "binary"
          });

          let buffer = new ArrayBuffer(xlsbin.length), array = new Uint8Array(buffer);

          for (let i=0; i<xlsbin.length; i++) {
            array[i] = xlsbin.charCodeAt(i) & 0XFF;
          }

          let xlsblob = new Blob([buffer], {type:"application/octet-stream"});

          // (C5) "FORCE DOWNLOAD"
          let url = window.URL.createObjectURL(xlsblob),
          anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = "Reporte de Stock.xlsx";
          anchor.click();
          window.URL.revokeObjectURL(url);
      });
    },
    filterByDate(movimientos) {
      const fechaDesde = this.filters[0]?.value;
      const fechaHasta = this.filters[1]?.value;
      return filterMovimientosByDate(movimientos, fechaDesde, fechaHasta);
    }
  },
};
</script>

<style scoped>
.dashboard-filters-card {
  max-width: 60%;
  width: 60%;
}
</style>